export default "__VITE_ASSET__27721b88__"